import i18next from 'i18next';

import { removeEmojis } from 'helpers/utils';

import { BorderedCell, CellSeparator } from '../pdfMakeUtils';
import { TicketData } from './getPdfTemplate';

const getTemplateTable = (ticketData: TicketData) => {
  const incidentDescriptionTable = {
    table: {
      widths: ['30%', '70%'],
      body: [
        [
          {
            text: `${i18next.t('ticket.pdf.description', {
              ns: 'global'
            })}`,
            style: 'titleBold',
            colSpan: 2
          },
          ''
        ],
        [
          {
            stack: [
              BorderedCell(
                `${i18next.t('ticket.pdf.attendedBy', {
                  ns: 'global'
                })}\n${
                  ticketData?.dataIncident?.ticketAssignedEngineerFullName ||
                  i18next.t('ticket.pdf.noData', {
                    ns: 'global'
                  })
                }`
              ),
              CellSeparator(),
              BorderedCell(
                `${i18next.t('ticket.pdf.serviceType', {
                  ns: 'global'
                })}:\n${
                  ticketData?.dataIncident?.ticketServiceTypeName ||
                  i18next.t('ticket.pdf.noData', {
                    ns: 'global'
                  })
                }`
              ),
              CellSeparator(),
              BorderedCell(
                `${i18next.t('common.commonProperties.serviceSingular', {
                  ns: 'global'
                })}:\n${ticketData?.dataIncident?.ticketServiceName || 'N/A'}`
              ),
              CellSeparator(),
              BorderedCell(
                `${i18next.t('common.commonProperties.declaredFailure', {
                  ns: 'global'
                })}:\n${
                  ticketData?.dataIncident?.ticketFrequentFailureName ||
                  i18next.t('ticket.pdf.noData', {
                    ns: 'global'
                  })
                }`
              ),
              CellSeparator(),
              BorderedCell(
                `${i18next.t('common.commonProperties.actualFailure', {
                  ns: 'global'
                })}:\n${
                  ticketData?.dataIncident?.ticketActualFailureName ||
                  i18next.t('ticket.pdf.noData', {
                    ns: 'global'
                  })
                }`
              )
            ]
          },
          {
            stack: [
              BorderedCell({
                text: `${i18next
                  .t('common.commonProperties.activitiesDescription', {
                    ns: 'global'
                  })
                  .toUpperCase()}:\n\n${
                  removeEmojis(
                    ticketData?.dataIncident?.onSiteTaskDescription
                  ) ?? ''
                }`,
                style: 'centerAreaText'
              })
            ],
            style: ['centerArea']
          }
        ]
      ]
    },
    layout: 'tableBorderedContainer'
  };

  return incidentDescriptionTable;
};

export default getTemplateTable;
